module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/raymond-pettit-bkg-e08b654fa4e7dbf9c920ed0c248fed25.jpg";